import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";
import {GROUPED_BY} from "../../@constants";

const OPTIONS = [
	{ label: 'General', value: GROUPED_BY.GENERAL },
	{ label: 'Market', value: GROUPED_BY.COUNTRY },
	{ label: 'Retailer', value: GROUPED_BY.RETAILER },
	{ label: 'Category', value: GROUPED_BY.CATEGORY },
	{ label: 'Brand', value: GROUPED_BY.BRAND },
	{ label: 'Sku', value: GROUPED_BY.SKU },
]

const __defaultOptions = op => op.value !== GROUPED_BY.SKU

export default function GroupedBySelect({ filterOptions=__defaultOptions, ...props }) {
	return <SelectSeeker
		label="Filter by"
		options={OPTIONS.filter(filterOptions)}
		{...props}
	/>
}